import { PageAudienceFilter, usePageFilterContext } from '@/components/page';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import ShareMenu from '@/features/ShareMenu';

type Props = {
  channelId: string;
  isLoading: boolean;
};

const ChannelDetailActions = ({ channelId, isLoading }: Props) => {
  const {
    pageFilters: { audience },
  } = usePageFilterContext();

  return (
    <div className="flex items-center gap-2">
      <PendoPlaceholder />
      <PageAudienceFilter disabled={isLoading} />
      <ShareMenu
        notificationPageKey="channel"
        notificationParams={{
          channelId: channelId,
          audienceId: audience?.id,
        }}
      />
    </div>
  );
};

export default ChannelDetailActions;
